module.exports = __webpack_public_path__ + "static/media/gloobinho.6bd13c45.svg";